import { gql } from "../../../__generated__/gql";

export const GET_VENDORS = gql(`
query vendors {
  vendors {
    id
    name
    image
    description
    type    
    socials
    links
    items
  }
}
`);

export const GET_VENDOR = gql(`
query vendor($id: String!) {
  vendor(where: {
    id: $id
  }) {
    id
    name
    image
    description
    type
    socials
    links
    items
  }
}
`);